module.exports = __webpack_public_path__ + "20f70760030899e98c4c1d621f2b9dfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/about-1.jpg
// module id = 1386
// module chunks = 0